import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import listText from "../utils/dictionaries/dictionary-contract-signature";
import Button from "../components/atoms/button";
import Top from "../components/templates/top";
import Link from "../components/atoms/link";
import Title from "../components/atoms/title";
import Paragraph from "../components/atoms/paragraph";
import Checkbox from "../components/molecules/checkbox";
import OtpUtilService from "../services/otpUtil.service";
import { store } from "../redux/store";
import { dateISO } from "../utils/helpers";
import { useDispatch } from "react-redux";
import { changeNavigate } from "../redux/slices/navigateReducer";
import { ValidateCodeUseCase } from "../../application/use-cases/validateCode.usecase";
import LinksSection from "../components/molecules/links-section";
import TitleAndImage from "../components/molecules/title-and-image";
import circleInfoSharpRegular from "../assets/icons/circle-info-sharp-regular.svg";
import InformationTextUtilService from "../services/informationTextUtil.service";
import { GeneralInformationTextUseCase } from "../../application/use-cases/generalInformationText.usecase";
import Loader from "../components/atoms/loader";
import MessagesReactModal from "../components/templates/messages-react-modal";
import hexagonExclamationThin from "../assets/icons/hexagon-exclamation-thin.svg";
import ic_xclose from "../assets/icons/ic_xclose.svg";

const ContractCondition = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const state = store.getState();
  const [activeSpinner, setActiveSpinner] = useState(false);
  const [checked, setChecked] = useState(false);
  const [incompleteData, setIncompleteData] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [informationList, setInformationList] = useState([]);

  const otpService = new OtpUtilService();
  const usecaseOtp = new ValidateCodeUseCase(otpService);

  const caseService = new InformationTextUtilService();
  const useCase = new GeneralInformationTextUseCase(caseService);

  const continueProcess = async () => {
    setActiveSpinner(true);
    if (state.client.dataPersist.isClient) {
      const responseOtp = await usecaseOtp.sendOtp(
        {
          phone: state.client.dataPersist.phone,
          email: state.client.dataPersist.email,
          channel: "SMS",
          date: dateISO(),
        },
        state.client.clientPersist.uuid,
      );
      if (responseOtp.error == null) {
        dispatch(
          changeNavigate({
            progressBarPercentage: "85%",
            editableValue: state.client.dataPersist.phone,
            typeValue: "phone",
            textButton: "Continuar",
            nextContinue: "/Congratulation",
            comeFrom: "ContractCondition",
            isReturn: true,
          }),
        );
        navigate("/ValidateCode");
      } else {
        setModalShow(true);
      }
    } else {
      navigate("/CustomerSignatureAction");
    }
    setActiveSpinner(false);
  };
  const acceptAuthorize = (value: boolean) => {
    setChecked(!value);
  };

  useEffect(() => {
    if (!state.client.dataPersist.isClient) {
      setChecked(true);
    }
    if (informationList.length == 0) {
      setChecked(false);
    }
  }, [informationList]);

  useEffect(() => {
    const getDocumentsData = async () => {
      setIncompleteData(true);
      const response = await useCase.listContractDocs();
      if (response.error != null) {
        setModalShow(true);
      } else {
        setInformationList(response.data[0].items);
      }
      setIncompleteData(false);
    };
    getDocumentsData();
  }, []);

  const onClickButtonLink = () => {
    navigate("/FollowLater", {
      state: {
        resource: "/ContractCondition",
        step: "CONTINUE_AFTER",
        data: {
          processId: state.client.clientPersist.uuid,
          phone: state.client.dataPersist.phone,
          latitude: "",
          longitude: "",
          acceptanceDate: dateISO(),
        },
      },
    });
    dispatch(
      changeNavigate({
        progressBarPercentage: "85%",
        editableValue: state.client.dataPersist.phone,
        typeValue: "phone",
        textButton: "Continuar",
        nextContinue: "/Congratulation",
        comeFrom: "ContractCondition",
        isReturn: true,
      }),
    );
  };

  return (
    <>
      {incompleteData ? (
        <Loader />
      ) : (
        <>
          <div className="content-container">
            <Top
              titleHeader={listText.text_1.mainText}
              subTitle={listText.text_2.mainText}
              displayProgressBar={""}
              displayLeftImageTitle={"d-none"}
              classTitleImage={"ms-2"}
              classHeader={"mt-2"}
              styleHeader={{}}
              classProgressBar={"mt-3"}
              styleProgressBar={{}}
              classTitleAndImage={""}
              styleTitleAndImage={{}}
              valueProgressBar={"80%"}
              comeFrom={"/ContractCondition"}
              onClickGoBackIcon={undefined}
            />
            <div className="p-3">
              <Title
                text={listText.text_3.mainText}
                className={""}
                styleTitle={{
                  color: "#00254A",
                  fontWeight: 500,
                }}
              />
              <Paragraph
                text={listText.text_4.mainText}
                className={"mt-3"}
                styleParagraph={undefined}
              />
              <Paragraph
                text={listText.text_5.mainText}
                className={""}
                styleParagraph={undefined}
              />
              {informationList.map((item: any) => {
                return (
                  <LinksSection
                    key={item.title}
                    url={item.url}
                    isDownload={true}
                    target={"_blank"}
                    className={""}
                    styleLink={{
                      fontSize: "16px",
                      color: "#004A94",
                      textDecorationLine: "underline",
                    }}
                    state={undefined}
                    text={item.title}
                    divStyleLinks={{}}
                    divClassLinks={"mb-3"}
                  />
                );
              })}
              <Paragraph
                text={
                  state.client.dataPersist.isClient
                    ? listText.text_6.mainText
                    : listText.text_10.mainText
                }
                className={"pt-4"}
                styleParagraph={undefined}
              />
              <div className="">
                {state.client.dataPersist.isClient ? (
                  <Checkbox
                    text={listText.text_7.mainText}
                    htmlFor={"flexCheckDefault"}
                    classNameLabel={"fs-7"}
                    classCheckbox={"form-check my-4_2"}
                    checked={checked}
                    onChange={() => {
                      acceptAuthorize(checked);
                    }}
                  />
                ) : (
                  <div className={`text-center`} style={{ backgroundColor: "#F7F7F7" }}>
                    <TitleAndImage
                      srcImage={circleInfoSharpRegular}
                      titleText={listText.text_11.mainText}
                      displayLeftImageTitle={""}
                      classTitle={"m-2"}
                      styleTitle={{
                        fontSize: "16px",
                        cursor: "pointer",
                        fontWeight: 400,
                        fontFamily: "Roboto",
                      }}
                      onClickTitleImgeDiv={undefined}
                      divClass={"py-3"}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="footer--pin">
            <Button
              text={listText.text_8.mainText}
              divClassName={"d-grid gap-2"}
              buttonClassName={`${
                !checked ? `button-disabled` : `button-enabled`
              } w-100 place-content-center align-self-center`}
              spinner={activeSpinner}
              onClick={() => {
                continueProcess();
              }}
              disabled={!checked}
              dataBsDismiss={undefined}
            />
            <div className="text-center mt-3">
              <Link
                text={listText.text_9.mainText}
                url={null}
                styleLink={{
                  color: "#5A6172",
                  lineHeight: "16px",
                  textDecoration: "none",
                  cursor: "pointer",
                }}
                onClick={() => onClickButtonLink()}
                className={""}
              />
            </div>
          </div>
        </>
      )}
      <MessagesReactModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        textTitle={listText.text_24.mainText}
        classTitle={"fw-bold"}
        styleTitle={{ color: "#00254A", fontSize: "20px", fontWeight: "700" }}
        listButtonsModal={[
          {
            text: listText.text_25.mainText,
            style: {},
            divClass: "",
            buttonClass: "button-enabled w-100 place-content-center align-self-center mt-3",
            spinner: false,
            onClick: () => setModalShow(false),
            disabled: false,
          },
        ]}
        imageModal={hexagonExclamationThin}
        onClickClose={() => setModalShow(false)}
        imageOnlyClose={ic_xclose}
        classContent={"ml-3 mr-3 mb-3 text-center"}
        classImageModal={"text-center my-4"}
        listParagraphs={[
          {
            textParagraph: listText.text_26.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
          {
            textParagraph: listText.text_27.mainText,
            classParagraph: "mt-2 mx-2",
            styleParagraph: { fontSize: 16, color: "#00254A", fontWeight: "450" },
          },
        ]}
      />
    </>
  );
};

export default ContractCondition;
